import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { useBreakpoint } from 'shared/lib';
import { router } from 'shared/routing';
import { userPageModel } from '../../model';
import cls from './user-page-heading.module.scss';

export const UserPageHeading = () => {
	const [user, back] = useUnit([userPageModel.$user, router.back]);

	const md = useBreakpoint('md');

	return (
		user !== null && (
			<div className={cls.userPageHeading}>
				<ActionIcon
					variant='outline'
					onClick={back}
				>
					<ChevronLeft />
				</ActionIcon>
				<Title
					order={1}
					size={md ? 'h1' : 'h3'}
					className={cls.userPageHeadingTitle}
				>
					{user.name}
				</Title>
			</div>
		)
	);
};
